import {Component, inject, OnDestroy, Signal} from '@angular/core';
import {stages} from '../../occupation-of-lane-placement-construction-objects.routes';
import {Store} from '@ngrx/store';
import {
  OccupationOfLanePlacementConstructionObjectsForm,
  occupationsToFormValue
} from './forms/occupation-of-lane-placement-construction-objects.form';
import {ApplicationAppEntityApplicationRead, RoadOccupationAppEntityApplicationRead} from '../../../../../../openapi';
import {
  selectApplication,
  selectApplicationState,
  selectLoading,
  selectPending
} from '../../../../../../store/selectors/application.selectors';
import {filter, map, Subscription} from 'rxjs';
import {ActivatedRoute, Router} from '@angular/router';
import {
  loadPurposeFeeCollection,
  updateOccupationOfLanePlacementConstructionObjects
} from '../../../../../../store/actions/application.actions';
import {StagesComponent} from '../../../../../../common/stages/stages.component';
import {SpinnerComponent} from '../../../../../../common/spinner/spinner.component';
import {
  OccupationOfLanePlacementConstructionObjectsFormComponent
} from './components/occupation-of-lane-placement-construction-objects-form/occupation-of-lane-placement-construction-objects-form.component';
import {ReactiveFormsModule} from '@angular/forms';
import {ServiceListItem} from '../../../../../../services/service.common.model';
import {selectServiceByUrl} from '../../../../../../store/selectors/app.selectors';

@Component({
  selector: 'app-occupation-of-lane-placement-construction-objects-section',
  standalone: true,
  imports: [
    StagesComponent,
    SpinnerComponent,
    OccupationOfLanePlacementConstructionObjectsFormComponent,
    ReactiveFormsModule
  ],
  providers: [
    OccupationOfLanePlacementConstructionObjectsForm
  ],
  templateUrl: './occupation-of-lane-placement-construction-objects-section.component.html'
})
export class OccupationOfLanePlacementConstructionObjectsSectionComponent implements OnDestroy {

  public stages: string[] = stages;

  private store$: Store = inject(Store);

  private route: ActivatedRoute = inject(ActivatedRoute);

  private router: Router = inject(Router);

  public form: OccupationOfLanePlacementConstructionObjectsForm = inject(OccupationOfLanePlacementConstructionObjectsForm);

  public application: Signal<ApplicationAppEntityApplicationRead | null> = this.store$.selectSignal(selectApplication);

  public pending: Signal<boolean> = this.store$.selectSignal(selectPending);

  public loading: Signal<boolean> = this.store$.selectSignal(selectLoading);

  private fetchApplicationData: Subscription = this.store$.select(selectApplicationState)
    .pipe(filter(v => !v.loading))
    .subscribe((state) => {
      const occupations: Array<RoadOccupationAppEntityApplicationRead> = state.application?.roadOccupations || [];
      const value = occupationsToFormValue(occupations).at(0) || null;
      this.form.patchFormValues({
        value,
        purposeFeeCollection: state.purposeFeeCollection
      });
    });

  private fetchRoadOccupationPurpose: Subscription = this.store$.select(selectApplication)
    .pipe(
      map(v => v?.roadOccupationPurpose?.purposeId || v?.service?.roadOccupationPurposes?.at(0)?.purposeId),
      filter(v => !!v)
    ).subscribe((purposeId) => {
      if (purposeId) {
        this.store$.dispatch(loadPurposeFeeCollection({purposeId}));
      }
    });

  public serviceType: Signal<ServiceListItem | null> = this.store$.selectSignal(selectServiceByUrl(this.route?.parent?.snapshot?.data['contentUrl']));

  public onCancel(): void {
    this.router.navigate(['../dane-wniosku'], {relativeTo: this.route});
  }

  public submitAndGoNext(): void {
    if (this.form.valid) {
      this.store$.dispatch(updateOccupationOfLanePlacementConstructionObjects({
        application: this.application(),
        occupations: [this.form.values],
        successFnc: (applicationId) => {
          this.router.navigate(
            ['../oplaty'],
            {
              relativeTo: this.route
            }
          );
        },
        failureFnc: () => {
        }
      }));
    } else {
      this.form.markAllAsTouched();
    }
  }

  public ngOnDestroy(): void {
    this.fetchApplicationData.unsubscribe();
    this.fetchRoadOccupationPurpose.unsubscribe();
  }
}
